export default __webpack_public_path__ + "static/media/breast4.196dc21e.jpg";